import { FLOWS_PRODUCTS_PATH } from '@flows/src/FlowsProductsRouter';
import { useRouteMatch } from 'react-router';

export interface FlowsRouteParams {
  flowId?: string;
  /**
   * tagId for anva from query string, originally it is a number but returned as string straight from the url
   * insurance code for yellowhive, inherited from anva structure
   * */
  tagId?: string;
}

interface RouteParams {
  flowId: string;
  tagId: string;
}

/**
 * Will only return a valid while inside a flows configure route
 *
 * In anva it is called a tag, in yellowhive it is called a category
 */
export const useFlowProductsOverviewParams = (): FlowsRouteParams => {
  const { params } =
    useRouteMatch<RouteParams>(
      `${FLOWS_PRODUCTS_PATH}/:flowId/overview/:tagId?`,
    ) || {};

  return {
    flowId: params?.flowId,
    tagId: params?.tagId,
  };
};
